import { io, type Socket } from 'socket.io-client';

/**
 * Socket.IO client singleton. Auto-connects, sends cookies for the
 * server-side session middleware, auto-reconnects on transient drops.
 *
 * The dev proxy (apps/web/vite.config.ts) forwards /socket.io to the
 * api on 5007; in prod the same path is fronted by nginx with the
 * upgrade-headers block from CLAUDE.md section 14.2.
 */

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    socket = io({
      path: '/socket.io',
      withCredentials: true,
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 500,
      reconnectionDelayMax: 5_000,
    });
  }
  return socket;
}

/** Tear down the singleton. Mostly for tests. */
export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
